import { withTheme } from "styled-components";
import RoundNotificationDefault, { RoundNotification } from "./components/RoundNotification.js";
export default withTheme(RoundNotificationDefault);
export { RoundNotification };
